import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOneToMany = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.334,
			cy: 11.6663,
			r: 1.375,
			transform: "rotate(-90 12.334 11.6663)",
			stroke: "currentColor",
			strokeWidth: .916667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 3.66699,
			cy: 7.99935,
			r: 1.375,
			transform: "rotate(-90 3.66699 7.99935)",
			stroke: "currentColor",
			strokeWidth: .916667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.334,
			cy: 4.33334,
			r: 1.375,
			transform: "rotate(-90 12.334 4.33334)",
			stroke: "currentColor",
			strokeWidth: .916667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6667 4.33333L9.33333 4.33333C8.59695 4.33333 8 4.93029 8 5.66667L8 10.3333C8 11.0697 8.59695 11.6667 9.33333 11.6667L10.6667 11.6667",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.33325 8L7.99992 8",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export { SvgOneToMany as ReactComponent };
